export default __webpack_public_path__ + "static/media/Mastercard.1dd433f7.svg";